import Http from "../../http/client";

export default async (id) => {
  const response = await Http.delete('admin/specialdays/'+id);
  return response.data;
}
